import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';
import { clearLast } from './notification-api.actions';
import * as fromPageActions from './notification-page.actions';

@Injectable()
export class NotificationEffects {
  private readonly duration = 3600;
  private readonly actions$ = inject(Actions<fromPageActions.Actions>);
  private readonly snackBar = inject(MatSnackBar);

  snackbarNotifySuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromPageActions.success.type),
      tap((action) => {
        this.snackBar.open(action.message, '', {
          duration: this.duration,
          panelClass: 'snackbar-success',
        });
      }),
      map(() => clearLast()),
    ),
  );

  snackbarNotifyFailure$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fromPageActions.failure.type),
      tap((action) => {
        this.snackBar.open(action.message, '', {
          duration: this.duration,
          panelClass: 'snackbar-failure',
        });
      }),
      map(() => clearLast()),
    ),
  );
}
